import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

import TheAuthenticatedLayout from '@/components/layout/TheAuthenticatedLayout.vue'
import TheGuestLayout from '@/components/TheGuestLayout.vue'
import CopilotPage from '@/views/copilot/CopilotPage.vue'
import AddonsPage from '@/views/addons/AddonsPage.vue'
import AudienceCreatePage from '@/views/audience/AudienceCreatePage.vue'
import AudienceDetailPage from '@/views/audience/AudienceDetailPage.vue'
import AudienceListPage from '@/views/audience/AudienceListPage.vue'
import AudienceRulesPage from '@/views/audience/AudienceRulesPage.vue'
import AudienceTemplatesPage from '@/views/audience/AudienceTemplatesPage.vue'
import AccountBlockedPage from '@/views/auth/AccountBlockedPage.vue'
import AutoLoginPage from '@/views/auth/AutoLoginPage.vue'
import ForgotPasswordPage from '@/views/auth/ForgotPasswordPage.vue'
import LoginPage from '@/views/auth/LoginPage.vue'
import ResetPasswordPage from '@/views/auth/ResetPasswordPage.vue'
import AutopilotsCopyTemplatePage from '@/views/autopilot/legacy/AutopilotsCopyTemplatePage.vue'
import AutopilotsDetailPage from '@/views/autopilot/legacy/AutopilotsDetailPage.vue'
import MarketingFlowCreateOrUpdatePage from '@/views/autopilot/MarketingFlowCreateOrUpdatePage.vue'
import MarketingFlowTemplatesPage from '@/views/autopilot/MarketingFlowTemplatesPage.vue'
import MarketingFlowPage from '@/views/autopilot/MarketingFlowPage.vue'
import CampaignCreatePage from '@/views/campaign/CampaignCreatePage.vue'
import CampaignDetailPage from '@/views/campaign/CampaignDetailPage.vue'
import CampaignEmailListPage from '@/views/campaignEmail/CampaignEmailListPage.vue'
import CampaignEmailCreatePage from '@/views/campaignEmail/CampaignEmailCreate/index.vue'
import CampaignEmailEditPage from '@/views/campaignEmail/EditCampaignEmail.vue'
import CampaignPage from '@/views/campaign/CampaignPage.vue'
import ContestsCreatePage from '@/views/contests/ContestsCreatePage.vue'
import ContestsDetailPage from '@/views/contests/ContestsDetailPage.vue'
import LegacyContestsDetailPage from '@/views/contests/legacy/LegacyContestsDetailPage.vue'
import LegacyContestsCreatePage from '@/views/contests/legacy/LegacyContestsCreatePage.vue'
import ContestsPage from '@/views/contests/ContestsPage.vue'
import CrmPage from '@/views/crm/CrmPage.vue'
import CustomerDetailPage from '@/views/customer/CustomerDetailPage.vue'
import DomainPage from '@/views/domain/DomainPage.vue'
import DomainConfigPage from '@/views/domain/DomainConfigPage.vue'
import CustomerListPage from '@/views/customer/CustomerListPage.vue'
import FraudSuspectCustomersPage from '@/views/customer/FraudSuspectCustomersPage.vue'
import CustomerStatisticsPage from '@/views/customer/CustomerStatisticsPage.vue'
import BusinessDashboardPage from '@/views/dashboard/BusinessDashboardPage.vue'
import CockpitDashboardPage from '@/views/dashboard/CockpitDashboardPage.vue'
import CustomersDashboardPage from '@/views/dashboard/CustomersDashboardPage.vue'
import DashboardPage from '@/views/dashboard/DashboardPage.vue'
import MarketingDashboardPage from '@/views/dashboard/MarketingDashboardPage.vue'
import RewardsPage from '@/views/dashboard/RewardsPage.vue'
import ExportPage from '@/views/export/ExportPage.vue'
import IconsPage from '@/views/IconsPage.vue'
import LoyaltyCreatePage from '@/views/loyalty/LoyaltyCreatePage.vue'
import LoyaltyPage from '@/views/loyalty/LoyaltyPage.vue'
import OfferDetailPage from '@/views/offer/OfferDetailPage.vue'
import OfferEditPage from '@/views/offer/OfferEditPage.vue'
import OfferListPage from '@/views/offer/OfferListPage.vue'
import TabletsPage from '@/views/loyaltySupports/tablets/TabletsPage.vue'
import WalletPage from '@/views/loyaltySupports/wallet/WalletPage.vue'
import WebappPage from '@/views/loyaltySupports/webapp/WebappPage.vue'
import MarketplacePage from '@/views/marketplace/MarketplacePage.vue'
import MissedCallsAnalyticsPage from '@/views/missedCalls/MissedCallsAnalyticsPage.vue'
import MissedCallsDetailPage from '@/views/missedCalls/MissedCallsDetailPage.vue'
import MissedCallsSettingsPage from '@/views/missedCalls/MissedCallsSettingsPage.vue'
import PartnersPage from '@/views/partners/PartnersPage.vue'
import ReviewAnalyticsPage from '@/views/review/ReviewAnalyticsPage.vue'
import ReviewPage from '@/views/review/ReviewPage.vue'
import ReviewSettingsPage from '@/views/review/ReviewSettingsPage.vue'
import RewardDetailPage from '@/views/reward/RewardDetailPage.vue'
import RewardPage from '@/views/reward/RewardPage.vue'
import ApiKeysPage from '@/views/settings/ApiKeysPage.vue'
import GoCardlessFlowPage from '@/views/settings/billing/GoCardlessFlowPage.vue'
import ImportHistoryPage from '@/views/settings/ImportHistoryPage.vue'
import SettingsPage from '@/views/settings/SettingsPage.vue'
import SettingsStoreDetailPage from '@/views/settings/SettingsStoreDetailPage.vue'
import SettingsStoresPage from '@/views/settings/SettingsStoresPage.vue'
import SettingsVisualIdentityPage from '@/views/settings/SettingsVisualIdentityPage.vue'
import SetupPage from '@/views/settings/SetupPage.vue'
import UsersPage from '@/views/settings/users/UsersPage.vue'
import SubscriptionPage from '@/views/subscription/SubscriptionPage.vue'
import SurveyEditPage from '@/views/survey/SurveyEditPage.vue'
import SurveyDetailPage from '@/views/survey/SurveyDetailPage.vue'
import SurveyPage from '@/views/survey/SurveyPage.vue'
import PreviewLinkPage from '@/views/message/PreviewLinkPage.vue'

import useAfterware from '@/composables/afterware'
import useMiddleware from '@/composables/middleware'
import MarketingFlowDetailPage from '@/views/autopilot/MarketingFlowDetailPage.vue'
import ImportPage from '@/views/import/ImportPage.vue'
import PartooPage from '@/views/partoo/PartooPage.vue'
import EReputationPage from '@/views/partoo/EReputationPage.vue'
import ReviewPlatformsPage from '@/views/reviewPlatforms/ReviewPlatformsPage.vue'
import StoreLocatorPage from '@/views/partoo/StoreLocatorPage.vue'
export const routes = [
  {
    path: '/autologin',
    name: 'Autologin',
    component: AutoLoginPage,
    meta: {
      guest: true
    }
  },
  {
    path: '/preview/:linkId',
    name: 'PreviewLink',
    component: PreviewLinkPage
  },
  {
    name: 'Guest',
    component: TheGuestLayout,
    redirect: 'login',
    path: '/',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: LoginPage,
        meta: {
          guest: true
        }
      },
      {
        path: 'account-blocked',
        name: 'AccountBlocked',
        component: AccountBlockedPage,
        meta: {
          guest: true
        }
      },
      {
        path: 'forgot',
        name: 'ForgotPassword',
        component: ForgotPasswordPage,
        meta: {
          guest: true
        }
      },
      {
        path: 'reset',
        name: 'ResetPassword',
        component: ResetPasswordPage,
        meta: {
          guest: true
        }
      }
    ]
  },
  {
    name: 'User',
    component: TheAuthenticatedLayout,
    path: '/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: CopilotPage
      },
      {
        path: '/design',
        name: 'DesignSystem',
        component: () => import('@/views/design/DesignSystemPage.vue')
      },
      {
        path: '/autopilots',
        name: 'AutopilotList',
        component: MarketingFlowPage,
        meta: {
          permissions: ['autopilot.read']
        }
      },
      {
        path: '/marketing-flow/templates',
        name: 'MarketingFlowTemplates',
        component: MarketingFlowTemplatesPage,
        meta: {
          permissions: ['autopilot.read']
        }
      },
      {
        path: 'autopilots/:autopilotId(\\d+)',
        name: 'AutopilotDetail',
        component: AutopilotsDetailPage,
        meta: {
          permissions: ['autopilot.read']
        }
      },
      {
        path: 'autopilots/copy/:templateId(\\d+)',
        name: 'AutopilotCopyTemplate',
        component: AutopilotsCopyTemplatePage
      },
      {
        path: 'marketing-flow/detail/:marketingFlowId(\\d+)',
        name: 'MarketingFlowDetail',
        component: MarketingFlowDetailPage,
        meta: {
          permissions: ['autopilot.read']
        }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardPage,
        meta: {
          permissions: ['dashboard.read']
        }
      },
      {
        path: 'dashboard/business',
        name: 'BusinessDashboard',
        component: BusinessDashboardPage,
        meta: {
          permissions: ['dashboard.read']
        }
      },
      {
        path: 'dashboard/marketing',
        name: 'MarketingDashboard',
        component: MarketingDashboardPage,
        meta: {
          permissions: ['dashboard.read']
        }
      },
      {
        path: 'dashboard/customers',
        name: 'CustomersDashboard',
        component: CustomersDashboardPage,
        meta: {
          permissions: ['dashboard.read']
        }
      },
      {
        path: 'dashboard/cockpit',
        name: 'CockpitDashboard',
        component: CockpitDashboardPage,
        meta: {
          permissions: ['dashboard.read']
        }
      },
      {
        path: 'dashboard/rewards',
        name: 'RewardPage',
        component: RewardsPage,
        meta: {
          permissions: ['reward.read']
        }
      },
      {
        path: 'campaigns',
        name: 'CampaignList',
        component: CampaignPage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['campaign.read']
        },
        beforeEnter: (to, from, next) => {
          if (to.query.type === 'offer') {
            next({ name: 'OfferList' })
          } else {
            next()
          }
        }
      },
      {
        path: 'campaigns/detail/:campaignId(\\d+)',
        name: 'CampaignDetail',
        component: CampaignDetailPage,
        meta: {
          permissions: ['campaign.read']
        }
      },
      {
        path: 'campaigns/create',
        name: 'CampaignCreate',
        component: CampaignCreatePage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['campaign.create']
        }
      },
      {
        path: 'campaign-email',
        name: 'CampaignEmailListPage',
        component: CampaignEmailListPage,
        meta: {
          permissions: ['campaign.read']
        }
      },
      {
        path: 'campaign-email/create',
        name: 'CampaignEmailCreatePage',
        component: CampaignEmailCreatePage,
        meta: {
          permissions: ['campaign.create']
        }
      },
      {
        path: 'campaign-email/edit/:campaignEmailId(\\d+)',
        name: 'CampaignEmailEditPage',
        component: CampaignEmailEditPage,
        meta: {
          permissions: ['campaign.create']
        }
      },
      {
        path: 'crm',
        name: 'CrmList',
        component: CrmPage,
        meta: {
          permissions: ['crm.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'analytics',
        name: 'CustomerAnalytics',
        component: CustomerStatisticsPage,
        meta: {
          permissions: ['customer.read']
        }
      },
      {
        path: 'customer',
        name: 'CustomerList',
        component: CustomerListPage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['customer.read']
        }
      },
      {
        path: 'customer/vigilance',
        name: 'FraudSuspectCustomers',
        component: FraudSuspectCustomersPage,
        meta: {
          permissions: ['customer.read']
        }
      },
      {
        path: 'customer/detail/:customerId',
        name: 'CustomerDetail',
        component: CustomerDetailPage,
        meta: {
          permissions: ['customer.read']
        }
      },
      {
        path: 'audiences',
        name: 'AudienceList',
        component: AudienceListPage,
        meta: {
          subscription: 'loyalty'
        }
      },
      {
        path: 'audiences/create',
        name: 'AudienceCreate',
        component: AudienceCreatePage,
        meta: {
          subscription: 'loyalty'
        }
      },
      {
        path: 'audiences/templates',
        name: 'AudienceTemplates',
        component: AudienceTemplatesPage,
        meta: {
          subscription: 'loyalty'
        }
      },
      {
        path: 'audiences/:audienceId',
        name: 'AudienceDetail',
        component: AudienceDetailPage,
        meta: {
          subscription: 'loyalty'
        }
      },
      {
        path: 'audiences/:audienceId/rules',
        name: 'AudienceRules',
        component: AudienceRulesPage,
        meta: {
          subscription: 'loyalty'
        }
      },
      {
        path: 'e-reputation/:page(stores|reviews|statistics|settings|settingsConnection|reviewAutoReplyWithoutComments|reviewAutoReplyWithComments|posts|analytics|presenceManagement)',
        name: 'EReputation',
        component: PartooPage,
        meta: {
          permissions: ['e-reputation.update'],
          subscription: 'e-reputation'
        }
      },
      {
        path: 'e-reputation/store-locator',
        name: 'EReputationStoreLocator',
        component: StoreLocatorPage,
        meta: {
          permissions: ['e-reputation.update'],
          subscription: 'e-reputation'
        }
      },
      {
        path: 'e-reputation',
        name: 'EReputationMenu',
        component: EReputationPage
      },
      {
        path: 'reviews',
        name: 'ReviewList',
        component: ReviewPage,
        meta: {
          permissions: ['review.read'],
          subscription: 'reviews'
        }
      },
      {
        path: 'reviews/settings',
        name: 'ReviewSettings',
        component: ReviewSettingsPage,
        meta: {
          permissions: ['review.read'],
          subscription: 'reviews'
        }
      },
      {
        path: 'reviews/analytics',
        name: 'ReviewAnalytics',
        component: ReviewAnalyticsPage,
        meta: {
          permissions: ['review.read'],
          subscription: 'reviews'
        }
      },
      {
        path: 'reviews/platforms',
        name: 'ReviewPlatformsList',
        component: ReviewPlatformsPage,
        meta: {
          permissions: ['e-reputation.update'],
          subscription: 'e-reputation'
        }
      },
      {
        path: 'surveys',
        name: 'SurveyList',
        component: SurveyPage,
        meta: {
          permissions: ['survey.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'surveys/create',
        name: 'SurveyCreate',
        component: SurveyEditPage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['survey.create'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'survey/detail/:surveyId(\\d+)',
        name: 'SurveyDetail',
        component: SurveyDetailPage,
        meta: {
          permissions: ['survey.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'survey/update/:surveyId(\\d+)',
        name: 'SurveyEdit',
        component: SurveyEditPage,
        meta: {
          permissions: ['survey.update'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'integrations',
        name: 'IntegrationList',
        component: MarketplacePage,
        meta: {
          permissions: ['marketplace.read']
        }
      },
      {
        path: 'loyalty-supports/tablets',
        name: 'TabletList',
        component: TabletsPage,
        meta: {
          permissions: ['marketplace.read']
        }
      },
      {
        path: 'loyalty/webapp',
        name: 'Webapp',
        component: WebappPage,
        meta: {
          permissions: ['marketplace.read']
        }
      },
      {
        path: 'loyalty-supports/wallet',
        name: 'Wallet',
        component: WalletPage,
        meta: {
          permissions: ['reward.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'export',
        name: 'ExportList',
        component: ExportPage
      },
      {
        path: 'setup/',
        name: 'Setup',
        component: SetupPage
      },
      {
        path: '/settings',
        redirect: '/settings/invoices'
      },
      {
        path: 'settings/invoices',
        name: 'InvoiceList',
        component: SettingsPage
      },
      {
        path: 'settings/gocardless',
        name: 'GoCardlessFlow',
        component: GoCardlessFlowPage
      },
      {
        path: 'settings/gocardless/success',
        name: 'GoCardlessFlowSuccess',
        component: GoCardlessFlowPage
      },
      {
        path: 'settings/history',
        name: 'ImportList',
        component: ImportHistoryPage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['import.read']
        }
      },
      {
        path: 'loyalty',
        name: 'LoyaltyEdit',
        component: LoyaltyPage,
        meta: {
          permissions: ['reward.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'rewards',
        name: 'RewardEdit',
        component: RewardPage,
        meta: {
          permissions: ['reward.read']
        }
      },
      {
        path: 'rewards/:rewardId(\\d+)',
        name: 'RewardDetail',
        component: RewardDetailPage,
        meta: {
          permissions: ['reward.read']
        }
      },
      {
        path: 'loyalty/create/',
        name: 'LoyaltyCreate',
        component: LoyaltyCreatePage,
        props: (route) => ({ query: route.query }),
        meta: {
          trackQuery: true,
          permissions: ['reward.read']
        }
      },
      {
        path: 'offers/create',
        name: 'OfferCreate',
        component: OfferEditPage,
        meta: {
          permissions: ['campaign.create'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'offers',
        name: 'OfferList',
        component: OfferListPage,
        meta: {
          permissions: ['campaign.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'offers/:offerId(\\d+)/edit',
        name: 'OfferEdit',
        component: OfferEditPage,
        meta: {
          permissions: ['campaign.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'offers/:offerId(\\d+)',
        name: 'OfferDetail',
        component: OfferDetailPage,
        meta: {
          permissions: ['campaign.read'],
          subscription: 'loyalty'
        }
      },
      {
        path: 'settings/stores',
        name: 'StoreList',
        component: SettingsStoresPage,
        meta: {
          permissions: ['global-configuration.read']
        }
      },
      {
        path: 'settings/users',
        name: 'UserList',
        component: UsersPage,
        meta: {
          permissions: ['permission.read']
        }
      },
      {
        path: 'settings/visual-identity',
        name: 'VisualIdentityEdit',
        component: SettingsVisualIdentityPage,
        meta: {
          permissions: ['global-configuration.read']
        }
      },
      {
        path: 'settings/domain',
        name: 'DomainSettings',
        component: DomainPage,
        meta: {
          permissions: ['global-configuration.read']
        }
      },
      {
        path: 'settings/domain/config',
        name: 'DomainConfig',
        component: DomainConfigPage,
        meta: {
          permissions: ['global-configuration.read']
        }
      },
      {
        path: 'settings/api-keys',
        name: 'ApiKeyList',
        component: ApiKeysPage
      },
      {
        path: 'settings/stores/:storeId(\\d+)',
        name: 'StoreEdit',
        component: SettingsStoreDetailPage,
        meta: {
          permissions: ['global-configuration.read']
        }
      },
      {
        path: 'contests/:isNew?',
        name: 'ContestList',
        component: ContestsPage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/create/:isNew?',
        name: 'ContestCreate',
        component: ContestsCreatePage,
        props: (route) => ({ query: route.query }),
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/detail/:contestId(\\d+)',
        name: 'ContestDetail',
        component: ContestsDetailPage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/legacy/detail/:contestId(\\d+)',
        name: 'LegacyContestDetail',
        component: LegacyContestsDetailPage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/edit/:contestId(\\d+)/:success?',
        name: 'ContestEdit',
        component: ContestsCreatePage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/legacy/edit/:contestId(\\d+)/:success?',
        name: 'LegacyContestEdit',
        component: LegacyContestsCreatePage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'contests/legacy/create',
        name: 'LegacyContestCreate',
        component: LegacyContestsCreatePage,
        meta: {
          permissions: ['contest-game.read'],
          subscription: 'game-contest'
        }
      },
      {
        path: 'missed-calls/params',
        name: 'MissedCallsList',
        component: MissedCallsSettingsPage,
        meta: {
          permissions: ['missed-call.read'],
          subscription: 'looping'
        }
      },
      {
        path: 'missed-calls/:storeId(\\d+)',
        name: 'MissedCallEdit',
        component: MissedCallsDetailPage,
        meta: {
          permissions: ['missed-call.read'],
          subscription: 'looping'
        }
      },
      {
        path: 'missed-calls/analytics',
        name: 'MissedCallAnalytics',
        component: MissedCallsAnalyticsPage,
        meta: {
          permissions: ['missed-call.read'],
          subscription: 'looping'
        }
      },
      {
        path: 'subscription',
        name: 'SubscriptionRegister',
        component: SubscriptionPage
      },
      {
        path: 'addons',
        name: 'AddonsList',
        component: AddonsPage
      },
      {
        path: 'partners',
        name: 'PartnersList',
        component: PartnersPage
      }
    ]
  },
  {
    name: 'FullscreenLayout',
    path: '/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'marketing-flow/create',
        name: 'MarketingFlowCreate',
        component: MarketingFlowCreateOrUpdatePage,
        meta: {
          permissions: ['autopilot.create']
        }
      },
      {
        path: 'marketing-flow/edit/:marketingFlowId(\\d+)',
        name: 'MarketingFlowEdit',
        component: MarketingFlowCreateOrUpdatePage,
        meta: {
          permissions: ['autopilot.update']
        }
      },
      {
        path: 'import',
        name: 'Import',
        component: ImportPage,
        meta: {
          permissions: ['customer.create']
        }
      },
      {
        path: 'icons',
        name: 'Icons',
        component: IconsPage
      }
    ]
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/dashboard'
  }
] as RouteRecordRaw[]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 }
  },
  routes
})

router.beforeEach(async (to, from, next) => {
  const { activatedMiddlewares } = useMiddleware(to, from, next)

  for (const middleware of activatedMiddlewares) {
    const isValid = middleware()
    if (!isValid) {
      return
    }
  }
  next()
})

router.afterEach(async (to) => {
  const { activatedAfterwares } = useAfterware(to)

  for (const afterware of activatedAfterwares) {
    afterware()
  }
})

export default router
